export const OutcomeTypes = Object.freeze({
    LOCAL_ISSUE: 1,
    SERVICE_WIDE: 2,
    NOTABLE_PRACTICE: 3,
});

export const sendTypes = Object.freeze({
    NO: 1,
    NEED_TO_SEND: 2,
    SENT: 3,
});

export const outcomeLearningType = Object.freeze({
    ROL: 'rol',
    NOL: 'nol',
    JOL: 'jol',
});
